import { request } from "./request";

const BASE_URL = "/api/project_notification_unsubscriptions";

export default {
  async unsubscribe(projectId) {
    return await request({
      url: `${BASE_URL}/${encodeURIComponent(projectId)}/unsubscribe`,
      method: "PUT",
    });
  },
};
